import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { startAutomationScheduler } from '../services/automationScheduler';
import { useAuth } from '../contexts/AuthContext';

/**
 * Component that initializes and starts the automation scheduler
 * This should be mounted once when the app starts
 */
const AutomationSchedulerInitializer = () => {
  const { currentUser } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (!currentUser) return;

    // `scheduledTriggers` is not readable under current rules for broad list queries during signup.
    // Skip the client scheduler on onboarding / auth flows to avoid permission noise and wasted work.
    const path = location.pathname;
    const skipScheduler =
      path.startsWith('/onboarding') ||
      path.startsWith('/verify-email') ||
      path.startsWith('/signup') ||
      path === '/login' ||
      path === '/forgot-password';

    if (skipScheduler) {
      return;
    }

    console.log('🚀 Starting automation scheduler...');

    const cleanup = startAutomationScheduler();

    console.log('✅ Automation scheduler started successfully');

    return () => {
      if (cleanup) {
        cleanup();
        console.log('🛑 Automation scheduler stopped');
      }
    };
  }, [currentUser, location.pathname]);

  // This component doesn't render anything
  return null;
};

export default AutomationSchedulerInitializer;

